import React from 'react';
import { NavBar } from '../Components/NavBar';
import { Footer } from '../Components/Footer';
import { Contact } from '../Components/Contact';

function Privacy() {
    return (
        <div>
            <NavBar />
            <Contact />

            <div className="privacy-main">
                <h1 className="text-center text-remesa">
                    Política de Privacidad
                </h1>

                <p>
                    <strong>Última actualización: 19-06-2026</strong>
                </p>

                <p>
                    La privacidad y la protección de los datos personales de
                    nuestros usuarios constituyen una prioridad. Esta Política
                    de Privacidad explica cómo recopilamos, utilizamos,
                    protegemos y conservamos la información personal facilitada
                    a través de nuestro sitio web y de los servicios ofrecidos.
                </p>

                <p>
                    Al utilizar nuestros servicios, el usuario declara haber
                    leído y aceptado la presente Política de Privacidad.
                </p>

                <h3>1. Compromiso con la Privacidad</h3>

                <p>
                    Nos comprometemos a tratar los datos personales de forma
                    lícita, leal y transparente, aplicando las medidas técnicas
                    y organizativas necesarias para garantizar su
                    confidencialidad, integridad y seguridad.
                </p>

                <p>
                    Nunca utilizaremos los datos personales para finalidades
                    distintas de aquellas para las que fueron obtenidos, salvo
                    obligación legal o autorización expresa del usuario.
                </p>

                <h3>2. Datos que Podemos Recopilar</h3>

                <p>
                    Durante la utilización de nuestros servicios podremos
                    recopilar información como:
                </p>

                <ul>
                    <li>Nombre y apellidos.</li>
                    <li>Fecha de nacimiento.</li>
                    <li>Nacionalidad.</li>
                    <li>Documento de identidad o pasaporte.</li>
                    <li>Dirección de residencia.</li>
                    <li>Correo electrónico.</li>
                    <li>Número de teléfono.</li>
                    <li>
                        Información bancaria necesaria para procesar
                        operaciones.
                    </li>
                    <li>Fotografías, selfies o videos de identificación.</li>
                    <li>
                        Información relacionada con el origen y destino de
                        fondos cuando resulte legalmente necesario.
                    </li>
                    <li>
                        Datos técnicos derivados de la navegación en el sitio
                        web.
                    </li>
                </ul>

                <h3>3. Finalidad del Tratamiento</h3>

                <p>
                    La información recopilada podrá utilizarse para:
                </p>

                <ul>
                    <li>
                        Gestionar solicitudes de información o contacto.
                    </li>
                    <li>
                        Prestar servicios de envío y recepción de dinero.
                    </li>
                    <li>
                        Verificar la identidad de los usuarios.
                    </li>
                    <li>
                        Cumplir obligaciones legales y regulatorias.
                    </li>
                    <li>
                        Prevenir el fraude, la suplantación de identidad y
                        actividades ilícitas.
                    </li>
                    <li>
                        Mejorar la calidad, seguridad y funcionamiento de los
                        servicios.
                    </li>
                    <li>
                        Atender consultas, incidencias o reclamaciones.
                    </li>
                    <li>
                        Cumplir requerimientos emitidos por autoridades
                        competentes.
                    </li>
                </ul>

                <h3>4. Procesos de Identificación y Seguridad</h3>

                <p>
                    Para garantizar la seguridad de nuestros usuarios y el
                    cumplimiento de la normativa aplicable, determinados
                    servicios podrán requerir procesos de identificación y
                    verificación de identidad.
                </p>

                <p>
                    Dichos procesos podrán incluir la presentación de documentos
                    oficiales, fotografías, videos de identificación y
                    cualquier otra información necesaria para validar la
                    identidad del usuario.
                </p>

                <p>
                    La validación podrá realizarse mediante proveedores
                    especializados en verificación de identidad que actúan bajo
                    estrictos estándares de seguridad y confidencialidad.
                </p>

                <h3>5. Base Legal del Tratamiento</h3>

                <p>
                    El tratamiento de los datos personales podrá fundamentarse
                    en:
                </p>

                <ul>
                    <li>El consentimiento otorgado por el usuario.</li>
                    <li>
                        La ejecución de un contrato o solicitud de servicios.
                    </li>
                    <li>El cumplimiento de obligaciones legales.</li>
                    <li>
                        La protección frente al fraude y la prevención de
                        actividades ilícitas.
                    </li>
                    <li>
                        El interés legítimo relacionado con la seguridad y
                        correcto funcionamiento de los servicios.
                    </li>
                </ul>

                <h3>6. Conservación de los Datos</h3>

                <p>
                    Los datos personales se conservarán durante el tiempo
                    necesario para cumplir con las finalidades descritas en esta
                    Política.
                </p>

                <p>
                    Cuando exista una obligación legal de conservación, la
                    información podrá mantenerse bloqueada durante los plazos
                    legalmente establecidos, incluso después de finalizada la
                    relación comercial.
                </p>

                <h3>7. Comunicación de Datos</h3>

                <p>
                    La información podrá ser compartida únicamente cuando
                    resulte necesario para:
                </p>

                <ul>
                    <li>La ejecución de los servicios solicitados.</li>
                    <li>El cumplimiento de obligaciones legales.</li>
                    <li>
                        La prevención del fraude y actividades ilícitas.
                    </li>
                    <li>
                        La verificación de identidad y seguridad de las
                        operaciones.
                    </li>
                    <li>
                        Atender requerimientos de organismos reguladores o
                        autoridades competentes.
                    </li>
                </ul>

                <p>
                    En ningún caso venderemos, alquilaremos o comercializaremos
                    datos personales de nuestros usuarios.
                </p>

                <h3>8. Transferencias Internacionales</h3>

                <p>
                    Cuando la prestación de los servicios implique
                    transferencias internacionales de información, se adoptarán
                    las medidas y garantías exigidas por la normativa vigente en
                    materia de protección de datos.
                </p>

                <h3>9. Derechos del Usuario</h3>

                <p>
                    Los usuarios podrán ejercer los derechos reconocidos por la
                    legislación aplicable, incluyendo:
                </p>

                <ul>
                    <li>Derecho de acceso.</li>
                    <li>Derecho de rectificación.</li>
                    <li>Derecho de supresión.</li>
                    <li>Derecho de limitación del tratamiento.</li>
                    <li>Derecho de oposición.</li>
                    <li>Derecho a la portabilidad de los datos.</li>
                </ul>

                <p>
                    Asimismo, podrán presentar reclamaciones ante la autoridad
                    competente en materia de protección de datos cuando
                    consideren que sus derechos han sido vulnerados.
                </p>

                <h3>10. Seguridad de la Información</h3>

                <p>
                    Aplicamos medidas técnicas, organizativas y de seguridad
                    destinadas a proteger la información frente a accesos no
                    autorizados, pérdida, alteración, divulgación o destrucción.
                </p>

                <p>
                    Entre dichas medidas se incluyen sistemas de cifrado,
                    conexiones seguras, controles de acceso, monitorización y
                    procedimientos internos de protección de datos.
                </p>

                <h3>11. Menores de Edad</h3>

                <p>
                    Los servicios ofrecidos están dirigidos exclusivamente a
                    personas mayores de edad con capacidad legal para contratar.
                </p>

                <p>
                    No recopilamos deliberadamente información personal de
                    menores de edad.
                </p>

                <h3>12. Modificaciones de la Política de Privacidad</h3>

                <p>
                    Nos reservamos el derecho de actualizar o modificar la
                    presente Política de Privacidad cuando resulte necesario
                    para adaptarla a cambios normativos, tecnológicos o de
                    funcionamiento de los servicios.
                </p>

                <p>
                    Las modificaciones serán publicadas en esta misma página y
                    entrarán en vigor desde su fecha de publicación.
                </p>
            </div>

            <Footer />
        </div>
    );
}

export { Privacy };

